const h = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.268 7.043h-1.516v4.277h1.516zm-4.121-.039H11.63v4.277h1.516zM6.732 3 3 6.577v12.79h4.51v3.538l3.732-3.538h2.993L21 12.953V3zm12.79 9.253L16.49 15.09h-2.993l-2.605 2.488V15.09H7.51V4.438h12.013z"/>
</svg>
`;
export {
  h as default
};
//# sourceMappingURL=twitch.21130e2d.mjs.map
